module.exports = __webpack_public_path__ + "static/media/cn.02c229de.svg";